import { c as _c } from "react/compiler-runtime";
import { CREATE_WAVE_INLINE_GROUP_RULE_LABELS, type CreateWaveInlineGroupRuleType } from "./createWaveInlineGroupBuilder";
import { DraftChipButton } from "./CreateWaveInlineGroupButtons";
export default function CreateWaveInlineGroupHeader(t0) {
  const $ = _c(18);
  const {
    currentStateLabel,
    showModeChips,
    identityChipLabel,
    disabled,
    isIdentityPanel,
    isRulePanel,
    isSearchPanel,
    configuredRules,
    onIdentityToggle,
    onRuleOpen,
    onRulesToggle,
    onSearchToggle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-iron-500">Current state</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currentStateLabel) {
    t2 = <p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-iron-50">{currentStateLabel}</p>;
    $[1] = currentStateLabel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== configuredRules || $[4] !== disabled || $[5] !== identityChipLabel || $[6] !== isIdentityPanel || $[7] !== isRulePanel || $[8] !== isSearchPanel || $[9] !== onIdentityToggle || $[10] !== onRuleOpen || $[11] !== onRulesToggle || $[12] !== onSearchToggle || $[13] !== showModeChips) {
    t3 = showModeChips && <div className="tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-gap-2"><span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-iron-500">Draft</span><DraftChipButton label={identityChipLabel} disabled={disabled} active={isIdentityPanel} isToggle={true} onClick={onIdentityToggle} />{!isRulePanel && configuredRules.map(rule => <DraftChipButton key={rule} label={CREATE_WAVE_INLINE_GROUP_RULE_LABELS[rule]} disabled={disabled} onClick={() => onRuleOpen(rule)} />)}<DraftChipButton label="Add rule" disabled={disabled} active={isRulePanel} isToggle={true} onClick={onRulesToggle} /><DraftChipButton label="Use existing group" disabled={disabled} active={isSearchPanel} isToggle={true} onClick={onSearchToggle} /></div>;
    $[3] = configuredRules;
    $[4] = disabled;
    $[5] = identityChipLabel;
    $[6] = isIdentityPanel;
    $[7] = isRulePanel;
    $[8] = isSearchPanel;
    $[9] = onIdentityToggle;
    $[10] = onRuleOpen;
    $[11] = onRulesToggle;
    $[12] = onSearchToggle;
    $[13] = showModeChips;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t2 || $[16] !== t3) {
    t4 = <div className="tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900/70 tw-p-3">{t1}{t2}{t3}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}